<template>
  <v-col>
    <v-select
      v-model="idTypeDiplome"
      label="Type de diplôme *"
      :items="typesDiplomes"
      item-value="id"
      item-text="libelle"
      :rules="typeDiplomeRules"
      @change="loadFormations(idTypeDiplome)"
    >
    </v-select>
    <template v-if="idTypeDiplome">
      <v-select
        v-model="idFormation"
        :rules="formationRules"
        label="Formation que vous souhaitez intégrer *"
        :items="formations"
        item-value="id"
        item-text="libelle"
        no-data-text="Aucune formation disponible"
        @change="loadAteliers()"
      >
      </v-select>

      <v-alert v-if="idFormation" type="info"
        >Dépôts de candidature pour cette formation du {{ dateOuverture }} au
        {{ dateFermeture }}</v-alert
      >

      <v-alert v-if="idFormation && ateliers.length == 0" type="warning"
        >Aucun atelier disponible pour l'instant.</v-alert
      >

      <v-data-table
        v-if="idFormation && ateliers.length > 0"
        :headers="headers"
        :items="ateliers"
        item-key="id"
        class="elevation-1"
        dense
        caption="Ateliers disponibles"
      >
        <template v-slot:item.action="{ item }">
          <ActionConfirmation
            icone="mdi-feather"
            title="Je m'inscris à cet atelier"
            @ok="inscription(item.id)"
          ></ActionConfirmation>
        </template>
      </v-data-table>
    </template>
  </v-col>
</template>
<script>
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import ApiAtelierRepository from "@/repositories/ApiAtelierRepository";
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";
import ActionConfirmation from "@/components/ActionConfirmation";

export default {
  name: "ChoixAtelier",
  components: { ActionConfirmation },
  data() {
    return {
      idFormation: null,
      idTypeDiplome: null,
      formations: [],
      typesDiplomes: [],
      ateliers: [],
      formationRules: [v => !!v || "Veuillez sélectionner la formation"],
      typeDiplomeRules: [
        v => !!v || "Veuillez sélectionner le type de diplôme"
      ],
      headers: [
        {
          text: "Date et heure début",
          align: "left",
          value: "dateDebut"
        },
        {
          text: "Campus",
          align: "center",
          value: "campus.libelle"
        },
        {
          text: "Lieu",
          align: "center",
          value: "lieu"
        },
        {
          text: "Action",
          align: "center",
          value: "action"
        }
      ]
    };
  },
  methods: {
    async loadAteliers() {
      try {
        const ateliers = await ApiAtelierRepository.getAteliers(
          this.idFormation
        );
        this.ateliers = ateliers;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async getFormations(idTypeDiplome) {
      try {
        const formations = await ApiFormationRepository.getFormationsREO(
          idTypeDiplome
        );
        this.formations = formations;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },

    async inscription(idAtelier) {
      try {
        await ApiEtudiantRepository.inscrireEtudiantAtelier(
          idAtelier,
          this.idFormation
        );
        this.$emit("inscription");
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async loadFormations(idTypeDiplome) {
      this.idFormation = null;
      this.ateliers = [];
      await this.getFormations(idTypeDiplome);
    },
    async getTypesDiplomes() {
      try {
        const typesDiplomes = await ApiFormationRepository.getTypesDiplomes();
        this.typesDiplomes = typesDiplomes;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    }
  },
  created() {
    this.getTypesDiplomes();
  },
  computed: {
    dateFermeture() {
      if (this.idFormation) {
        let formationSelect = this.formations.find(
          x => x.id == this.idFormation
        );
        return formationSelect.dateFermeture;
      } else {
        return "";
      }
    },
    dateOuverture() {
      if (this.idFormation) {
        let formationSelect = this.formations.find(
          x => x.id == this.idFormation
        );
        return formationSelect.dateOuverture;
      } else {
        return "";
      }
    }
  }
};
</script>
